import { ref } from "vue";

export function useWhatsAppActions(
  activeInteractionTab: any,
  loadConversationsForChannel: (channel: string) => Promise<void>,
  toast: any
) {
  const forwardingMessage = ref<any>(null);
  const showForwardModal = ref(false);
  const showStartChatModal = ref(false);
  const isCreatingChat = ref(false);
  const forwardableConversations = ref<any[]>([]);

  async function handleCreateChat(request: any) {
    try {
      isCreatingChat.value = true;
      const Unipile = (await import("@/services/unipile/unipile")).default;
      const response = await Unipile.createGroupChat(request);

      if (response.data?.status && response.data?.data) {
        toast.success("Chat created successfully");
        showStartChatModal.value = false;
        await loadConversationsForChannel("whatsapp");
      }
    } catch (error) {
      console.error("Failed to create chat:", error);
      let errorMessage = "Failed to create chat";

      if ((error as any).response?.data?.message) {
        errorMessage = (error as any).response.data.message;
      } else if ((error as any).response?.data?.errorMessage) {
        errorMessage = (error as any).response.data.errorMessage;
      } else if ((error as any).message) {
        errorMessage = (error as any).message;
      }

      if (
        errorMessage.includes("account") ||
        errorMessage.includes("Account") ||
        errorMessage.includes("account_id")
      ) {
        errorMessage = "Invalid account. Please select a connected account.";
      } else if (
        errorMessage.includes("attendee") ||
        errorMessage.includes("Attendee") ||
        errorMessage.includes("attendees")
      ) {
        errorMessage = "Invalid recipient. Please check the attendee IDs.";
      } else if (
        errorMessage.includes("character") ||
        errorMessage.includes("limit") ||
        errorMessage.includes("length")
      ) {
        errorMessage = "Message exceeds character limit. Please shorten your message.";
      }

      toast.error(errorMessage);
    } finally {
      isCreatingChat.value = false;
    }
  }

  async function handleForwardConfirm(chatId: string) {
    if (!forwardingMessage.value) return;

    if (
      forwardingMessage.value.channel !== "whatsapp" &&
      activeInteractionTab.value !== "whatsapp"
    ) {
      toast.error("Forwarding is only supported for WhatsApp messages");
      showForwardModal.value = false;
      forwardingMessage.value = null;
      return;
    }

    try {
      const Unipile = (await import("@/services/unipile/unipile")).default;
      await Unipile.forwardMessage(forwardingMessage.value.id, {
        chat_id: chatId,
      });
      toast.success("Message forwarded successfully");
      showForwardModal.value = false;
      forwardingMessage.value = null;

      await loadConversationsForChannel(activeInteractionTab.value);
    } catch (error) {
      console.error("Failed to forward message:", error);
      const errorMessage =
        (error as any).response?.data?.message || "Failed to forward message. Please try again.";
      toast.error(errorMessage);
    }
  }

  function handleForwardSearch() {
    // Empty stub — template-bound @search="handleForwardSearch"
  }

  function handleForwardLoadMore() {
    // Empty stub — template-bound @load-more="handleForwardLoadMore"
  }

  return {
    forwardingMessage,
    showForwardModal,
    showStartChatModal,
    isCreatingChat,
    forwardableConversations,
    handleCreateChat,
    handleForwardConfirm,
    handleForwardSearch,
    handleForwardLoadMore,
  };
}
